import { call, put, select, takeLeading } from 'typed-redux-saga'
import {
	errorHandler,
	AdvertisingNS,
	advertisingSlice,
	getRegionByIpSaga,
	regionByIpSlice,
	regionByIpSelectors,
	advertApi,
	loadersSlice,
} from 'Modules'
import { authApi, authSlice } from 'Pages/auth'

export function* updateAdvertisingSaga(action: AdvertisingNS.UpdateAdvertising) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { callback, data, id } = action.payload
		yield* call(getRegionByIpSaga, regionByIpSlice.actions.getRegion())
		const region = yield* select(regionByIpSelectors.getRegion)
		const currentTimezone =
			region?.utc_offset > 0 ? `+${String(region?.utc_offset)}` : String(region?.utc_offset)
		yield* call(advertApi.updateAdvertising, id, {
			...data,
			area_name: region?.name,
			timezone: currentTimezone,
		})
		const user = yield* call(authApi.getUser, action.payload.id)
		yield* put(authSlice.actions.setUser(user))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* advertisingSaga() {
	yield* takeLeading(advertisingSlice.actions.updateAdvertising.type, updateAdvertisingSaga)
}
